import React, { Component } from 'react'
class Included extends Component {

  constructor(props) {
    super(props)
  }

  getBuildDescription(){

  }

  render (){
    const { onClick, included } = this.props
    return(
    <div>
       <ul className="check-list">
         <li>
             <input type="checkbox" name="toggle" onChange={onClick} checked={included}/>
             <label>&nbsp;{(() => {
               return included ? 'Included in build' : 'Excluded from build'
             })()}</label>
         </li>
       </ul> 
    </div>
    )
  }
}

export default Included



// WEBPACK FOOTER //
// ./styleguide/components/Included.js